export var RewardEventTypesEnum;
(function (RewardEventTypesEnum) {
    RewardEventTypesEnum["USER_VERIFICATION"] = "USER_VERIFICATION";
})(RewardEventTypesEnum || (RewardEventTypesEnum = {}));
//# sourceMappingURL=reward-event-types.enum.js.map